import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {

  static targets = [ "questionFields", "alternateHiddenField" ]

  alternateSelectionChange(ev) {
    var {target} = ev
    var {checked} = target
    this.element.querySelectorAll('.alternate input').forEach(e => { if (e != target) e.checked = false })
    if (checked) {
      this.hide("questionFields")
      this.saveSameAs(target.value)
    } else {
      this.show("questionFields")
      this.saveSameAs(null)
    }
  }

  saveSameAs(sameAs) {
    let params = {_method: "put", answer: {answer_fields: { same_as: sameAs }}}
    let $question = $(this.element)
    $question.find('.status.icon').attr('class', 'spinner loading status icon').popup('destroy')

    $.post("/l/answers/" + this.data.get('answer-id'), params, (data, status) => {
      $question.find('.status.icon').attr('class', 'green check circle status icon')
    }).fail(function(xhr, status, error) {
      $question.find('.status.icon')
        .attr('class', 'red minus circle status icon')
        .popup({
          content: error + ' (' + xhr.status + ')',
          position: 'top center',
          variation: 'tiny',
        })
    })
  }
}
